export default __webpack_public_path__ + "static/media/givingeffbanner.13ee85d1.jpg";